import Link from 'next/link'
import React from 'react'
import { Header } from '../../components/marketing/Header'
import Meta from '../../components/Meta'
import { Marketing } from '../../designsystem/Text'
import { docsPages } from '../../utils/docs-pages'

export default function DocsHome() {
  return (
    <div className='bg-light'>
      <div className='relative overflow-hidden'>
        <Header />

        <Meta
          title='Documentation – GraphCDN'
          description='Get answers to all your questions about GraphCDN.'
        />
        <div className='pt-16 pb-12'>
          <div className='max-w-3xl px-8 mx-auto space-y-3'>
            <Marketing.H1>Documentation</Marketing.H1>
          </div>
        </div>
        <main className='max-w-3xl px-8 mx-auto mt-12 mb-24 space-y-4'>
          <p className='prose'>
            If you have any questions that aren't answered here, feel free to
            ping us anytime at{' '}
            <a
              href='mailto:support@graphcdn.io'
              onClick={(evt) => {
                // If Intercom is loaded, send them there
                // otherwise send them to the email link below
                // @ts-ignore
                if (window.Intercom?.booted) {
                  evt.preventDefault()
                  // @ts-ignore
                  window.Intercom('show')
                }
              }}
            >
              support@graphcdn.io
            </a>
            !
          </p>
          <div className='grid gap-16 pt-10 mt-6 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12'>
            {Object.keys(docsPages).map((slug) => (
              <DocsItem slug={slug} {...docsPages[slug]} />
            ))}
          </div>
        </main>
      </div>
    </div>
  )
}

function DocsItem({ title, description, slug }) {
  return (
    <div>
      <Link href={`/docs/${slug}`}>
        <a className='block mt-2 gotham'>
          <p className='text-3xl font-medium text-gray'>{title}</p>
          <p className='mt-3 text-lg text-gray opacity-70'>{description}</p>
        </a>
      </Link>
      <div className='mt-3'>
        <Link href={`/docs/${slug}`}>
          <a className='text-lg font-medium text-gray gotham'>Read more</a>
        </Link>
      </div>
    </div>
  )
}
